import React from 'react';

class HelpComponent extends React.Component{
    closeModal(){
        this.props.onHelpClick("None");        
    }
    render(){
        const videoSrc = this.props.videoSrc;
        return(
            <div className="ts modals dimmer active" style={{width:"100vw",height:"100vh",zIndex:"200000",left:"0px"}}>
                <dialog className="ts modal" open>
                    <i className="close icon" onClick={this.closeModal.bind(this)}></i>
                    <div className="content">
                        <iframe title="Help" width="856" height="545" src={videoSrc} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </dialog>
            </div>    
        );
    }
}

export default HelpComponent;